import React from 'react';
import FlashNotificationContext from './FlashNotificationContext';

const withFlashNotification = (WrappedComponent) => {
  const WithFlashNotification = (props) => (
    <FlashNotificationContext.Consumer>
      {(context) => (
        <WrappedComponent
          {...props}
          showFlashNotification={context ? context.showFlashNotification : () => {}}
        />
      )}
    </FlashNotificationContext.Consumer>
  );

  WithFlashNotification.displayName = `withFlashNotification(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return WithFlashNotification;
};

export default withFlashNotification;
